import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';

export const settingsCustomFieldsOrdersConfig = {
    all:  {
        title: 'custom_fields_orders',
        icon: <PlaylistAddIcon/>,
        isSingleDataGrid: true,
    },
};
